export const actionType = {
  GET_NON_SUBSCRIBER_REQUEST: 'GET_NON_SUBSCRIBER_REQUEST',
  GET_NON_SUBSCRIBER_RECEIVED: 'GET_NON_SUBSCRIBER_RECEIVED',
  GET_ERROR_PAGE_REQUEST: 'GET_ERROR_PAGE_REQUEST',
  GET_ERROR_PAGE_RESPONSE: 'GET_ERROR_PAGE_RESPONSE'
}
export const getNonSubscriberPageData = () => ({
  type: actionType.GET_NON_SUBSCRIBER_REQUEST,
});
  
export const errorPageData = () => ({
  type: actionType.GET_ERROR_PAGE_REQUEST,
});